<template>
  <div class="library-wrapper">
    <v-lazy min-height="200">
      <div class="library-items">
        <div
          class="library-item"
          v-for="(value) in svgs"
          :key="value"
          @click="selectFromLibrary(value)"
        >
          <SvgIcon :icon="{svg: value}"></SvgIcon>
        </div>
      </div>
    </v-lazy>
  </div>
</template>

<script>
import SvgIcon from "./SvgIcon";
import projectMixin from "./project/project-mixin";

export default {
  components: { SvgIcon },
  mixins: [projectMixin],
  props: ["svgs"],
  methods: {
    selectFromLibrary(svg) {
      this.$emit("input", {
        svg: svg
      });
    }
  }
};
</script>

<style scoped>
.library-wrapper {
  max-height: 300px;
  overflow-y: auto;
}
.library-items {
  width: 250px;
  display: flex;
  flex-wrap: wrap;
}
.library-item {
  width: 25%;
  height: 60px;
  background-color: white;
  padding: 8px;
  cursor: pointer;
  margin-bottom: 10px;
}
.library-item:hover {
  background-color: #efefef;
}
</style>